import { render, staticRenderFns } from "./bounty-surprise.vue?vue&type=template&id=a6cb74d6&scoped=true&lang=pug&"
import script from "./bounty-surprise.vue?vue&type=script&lang=js&"
export * from "./bounty-surprise.vue?vue&type=script&lang=js&"
import style0 from "./bounty-surprise.vue?vue&type=style&index=0&id=a6cb74d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cb74d6",
  null
  
)

export default component.exports